// Title and description of each public page, shared by the pages themselves
// and by the pre-rendering script run after the build (scripts/prerender.mjs)

export const PAGES = {
  home: {
    path: "/",
    title: "Platform98 - Vos démarches administratives en ligne au Cameroun",
    description:
      "Créez, domiciliez et gérez votre entreprise en ligne : création d'entreprise, domiciliation, NIU, CNPS, OAPI et formalités suivies en temps réel.",
  },
  formalities: {
    path: "/formalities",
    title: "Formalités administratives en ligne - Platform98",
    description:
      "NIU, conformité fiscale, CNPS, OAPI, importateurs, identité visuelle, casier judiciaire… Commandez vos formalités en ligne et suivez-les.",
  },
  pricing: {
    path: "/pricing",
    title: "Tarifs - Platform98",
    description:
      "Les tarifs de Platform98 : création d'entreprise, domiciliation, gestion et formalités administratives, avec des prix clairs et sans surprise.",
  },
  faq: {
    path: "/faq",
    title: "Questions fréquentes - Platform98",
    description:
      "Compte, paiement Mobile Money ou carte, documents, délais et formalités : les réponses aux questions les plus fréquentes sur Platform98.",
  },
  guide: {
    path: "/guide",
    title: "Guide de l'entrepreneur au Cameroun - Platform98",
    description:
      "Créer une entreprise au Cameroun, choisir sa forme juridique, obtenir son NIU, protéger son nom à l'OAPI : nos guides pratiques pour entreprendre.",
  },
  privacy: {
    path: "/privacy-policy",
    title: "Politique de confidentialité - Platform98",
    description:
      "Comment Platform98 collecte, utilise et protège vos données personnelles.",
  },
  terms: {
    path: "/terms-and-conditions",
    title: "Conditions générales - Platform98",
    description:
      "Les conditions générales d'utilisation et de vente des services de Platform98.",
  },
};

export const articlePage = (article) => ({
  path: `/guide/${article.slug}`,
  title: `${article.seoTitle} - Platform98`,
  description: article.description,
});
